import { render, staticRenderFns } from "./ConsentConfigModal.vue?vue&type=template&id=f5598dd8&scoped=true"
import script from "./ConsentConfigModal.vue?vue&type=script&lang=js"
export * from "./ConsentConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ConsentConfigModal.vue?vue&type=style&index=0&id=f5598dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5598dd8",
  null
  
)

export default component.exports